// Dashboard Users activity page translations (pt-BR), loaded into dashboard.users.activity by ../pt-BR.users.js
module.exports = {
  menu: "Atividade",
  title: "Atividade dos Utilizadores",
  description: "DAU, WAU, MAU, sessões, recorrentes e inativos.",
  kpis: {
    dau: "DAU (média no período)",
    wau: "WAU (7 dias)",
    mau: "MAU (30 dias)",
    stickiness: "Stickiness DAU / MAU",
    sessions: "Sessões",
    avgSession: "Tempo médio por sessão",
    retention30: "Retenção 30 dias",
    inactive: "Utilizadores inativos (30+ dias)",
  },
  info: {
    dau: "Média de utilizadores únicos por dia no período (utilizadores ativos diários).\nFonte: Google Analytics (sem ele, Firebase: registo de atividade enviado pelas apps).",
    wau: "Utilizadores únicos nos 7 dias até ao fim do período (utilizadores ativos semanais).\nFonte: Google Analytics (sem ele, Firebase: registo de atividade enviado pelas apps).",
    mau: "Utilizadores únicos nos 30 dias até ao fim do período (utilizadores ativos mensais).\nFonte: Google Analytics (sem ele, Firebase: registo de atividade enviado pelas apps).",
    stickiness: "Parte dos utilizadores do mês que usa a app num dia típico (DAU ÷ MAU); quanto mais alto, mais frequente o uso.\nFonte: Google Analytics (sem ele, Firebase: registo de atividade enviado pelas apps).",
    sessions: "Vezes que a app foi aberta no período.\nFonte: Google Analytics (sem ele, Firebase: registo de atividade enviado pelas apps).",
    avgSession: "Tempo médio de cada sessão na app no período.\nFonte: Google Analytics (sem ele, Firebase: registo de atividade enviado pelas apps).",
    retention30: "Utilizadores que entraram pela primeira vez no período e voltaram à app 30 dias depois.\nFonte: Google Analytics (sem ele, Firebase: registo de atividade enviado pelas apps).",
    inactive: "Utilizadores registados que não usaram a app nos 30 dias até ao fim do período (total registado menos o MAU).\nFonte: Firebase (índice de perfis) e Google Analytics (sem ele, Firebase: registo de atividade enviado pelas apps).",
  },
  hints: {
    shorterThan7: "período inferior a 7 dias",
    shorterThan30: "período inferior a 30 dias",
    needsMau: "requer MAU (período ≥ 30 dias)",
    cohortsAverage: "média das coortes",
    cohortsRange: "coortes de {start} a {end}",
    noOldAccounts: "ninguém no período tem 30 dias de conta",
  },
  modals: {
    dau: {
      title: "DAU",
    },
    sessions: {
      title: "Sessões",
    },
  },
  series: {
    dau: "DAU",
    wau: "WAU",
    mau: "MAU",
  },
  panels: {
    evolution: "DAU, WAU e MAU por {gran}",
    split: "Novos, recorrentes e inativos",
    weekday: "Sessões por dia da semana",
    funnel: "Funil de atividade",
  },
  split: {
    recurring: "Recorrentes",
    new: "Novos",
    inactive: "Inativos (30+ dias)",
    users: "utilizadores",
  },
  weekdays: {
    mon: "Segunda-feira",
    tue: "Terça-feira",
    wed: "Quarta-feira",
    thu: "Quinta-feira",
    fri: "Sexta-feira",
    sat: "Sábado",
    sun: "Domingo",
  },
  weekdaysShort: {
    mon: "Seg",
    tue: "Ter",
    wed: "Qua",
    thu: "Qui",
    fri: "Sex",
    sat: "Sáb",
    sun: "Dom",
  },
  funnel: {
    registered: "Registados",
    active30: "Ativos 30 dias",
    active7: "Ativos 7 dias",
    activeLast: "Ativos no dia {date}",
  },
  panelInfo: {
    evolution: "Utilizadores ativos por dia (DAU), nos 7 dias (WAU) e nos 30 dias (MAU) até ao fim de cada intervalo.\nFonte: Google Analytics (sem ele, Firebase: registo de atividade enviado pelas apps).",
    split: "Utilizadores ativos novos e recorrentes do período e os registados sem uso há 30 dias ou mais.\nFonte: Google Analytics (sem ele, Firebase: registo de atividade enviado pelas apps) e Firebase (índice de perfis).",
    weekday: "Sessões em cada dia da semana no período.\nFonte: Google Analytics (sem ele, Firebase: registo de atividade enviado pelas apps).",
    funnel: "Utilizadores registados, ativos nos 30 e nos 7 dias até ao fim do período e ativos no último dia.\nFonte: Firebase (índice de perfis) e Google Analytics (sem ele, Firebase: registo de atividade enviado pelas apps).",
  },
};
